// Product_Expiry_List_Container.jsx
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { toast } from 'react-toastify';
import Product_Expiry_List_Component from "./component";

const Product_Expiry_List_Container = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productListDetailsData, setProductExpiryDetailsData] = useState(null);

  const fetchProductDetailsData = () => {
    setLoading(true);
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/mvs/vendingmachines?mvId=${id}`,
      "GET",
      undefined,
      (response) => {
        setProductExpiryDetailsData(response);
        setLoading(false);
      },
      (error) => {
        setError("Failed to fetch products");
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchProductDetailsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const formatCurrency = (amount) => {
    return `₹${parseFloat(amount || 0).toFixed(2)}`;
  };

  // Expire Now: callback is called ONLY on API success
  const handleExpireNow = (selectedItems, callback) => {
    const payload = {
      mvId: parseInt(id),
      vmId: selectedItems.map(vending_machine_id => parseInt(vending_machine_id))
    };

    props.getDataFromAPI(
      "/dashboard/api/v2/admin/mvs/vendingmachines/expire",
      "POST",
      payload,
      (response) => {
        // API success
        toast.success("Products expired successfully");
        if (callback) callback(response);
        fetchProductDetailsData(); // Refresh data
      },
      (error) => {
        // API error -> do NOT call callback
        toastr.error(error?.message || "Failed to expire products");
        console.error("Expire error:", error);
      }
    );
  };

  // Expire Later: callback is called ONLY on API success
  const handleExpireLater = (selectedItems, timestamp, callback) => {
    const payload = {
      timestamp: timestamp,
      mvId: parseInt(id),
      vmId: selectedItems.map(vending_machine_id => parseInt(vending_machine_id))
    };

    props.getDataFromAPI(
      "/dashboard/api/v2/admin/mvs/vendingmachines/expire/scheduled",
      "POST",
      payload,
      (response) => {
        toast.success("Products scheduled for expiry successfully");
        if (callback) callback(response);
        fetchProductDetailsData(); 
      },
      (error) => {
        toastr.error(error?.message || "Failed to schedule expiry");
        console.error("Schedule error:", error);
      }
    );
  };

  // Cancel scheduled expiry: signature changed to (selectedItems, callback)
  const handleCancelProduct = (selectedItems, callback) => {
    const payload = {
      mvId: parseInt(id),
      vmId: selectedItems.map(vending_machine_id => parseInt(vending_machine_id))
    };

    props.getDataFromAPI(
      "/dashboard/api/v2/admin/mvs/vendingmachines/expire/scheduled/cancel",
      "PATCH",
      payload,
      (response) => {
        toast.success("Scheduled expiry cancelled successfully");
        if (callback) callback(response);
        fetchProductDetailsData(); 
      },
      (error) => {
        toastr.error(error?.message || "Failed to cancel scheduled expiry");
        console.error("Cancel schedule error:", error);
      }
    );
  };

  return (
    <Product_Expiry_List_Component
      productListDetailsData={productListDetailsData}
      loading={loading}
      error={error}
      navigate={navigate}
      formatCurrency={formatCurrency}
      onExpireNow={handleExpireNow}
      onExpireLater={handleExpireLater}
      handleCancelProduct={handleCancelProduct}
    />
  );
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(Product_Expiry_List_Container);
